import { Theme } from '@mui/material/styles'
import { css } from '@emotion/react'

// Modal Box style (was inline in Box)
export const modalBoxStyle = {
  backgroundColor: 'white',
  padding: '16px',
  margin: '40px auto',
  maxWidth: '600px',
  outline: 'none',
}

// Table container style
export const tableContainerStyle = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};
  box-shadow: ${theme.shadows[1]};
  border-radius: ${theme.shape.borderRadius};

  tr {
    cursor: pointer;
    user-select: none;
  }
`

// Table head style
export const tableHeadStyle = (theme: Theme) => ({
  backgroundColor: theme.palette.grey[100],
})

// Table header cell style
export const tableHeaderCellStyle = (theme: Theme) => ({
  fontWeight: 600,
  fontSize: '1rem',
  color: theme.palette.text.primary,
  padding: '12px 16px',
})

// Table cell style
export const tableCellStyle = (theme: Theme) => ({
  fontSize: '0.95rem',
  color: theme.palette.text.secondary,
  padding: '8px 16px',
})

export const contentStyles = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: stretch;
  min-height: 400px;
  max-height: 400px;
  overflow-y: auto;

  ${theme.breakpoints.up('md')} {
    flex-direction: row;
  }

  ${theme.breakpoints.down('md')} {
    max-height: initial;
  }
`

export const warningBoxStyle = (theme: Theme) => css`
  background-color: ${theme.palette.warning[100]};
  color: ${theme.palette.black.main};
  padding-top: ${theme.spacing(2)};
  padding-bottom: ${theme.spacing(2)};
  padding-left: ${theme.spacing(2)};
  padding-right: ${theme.spacing(2)};
  border-radius: ${theme.shape.borderRadius};
  margin: ${theme.spacing(2)};
  margin-bottom: 0;
  display: flex;
  gap: ${theme.spacing(1)};
  align-items: center;
  font-weight: 500;
  line-height: 1.25;
`
